export const searchPath = (query: string) =>
  query ? `/search/${encodeURIComponent(query)}` : '/search';

export const queryFromSearchPath = (pathname: string) => {
  if (!pathname.startsWith('/search/')) return undefined;
  try {
    return decodeURIComponent(pathname.slice('/search/'.length));
  } catch {
    return pathname.slice('/search/'.length);
  }
};
